import { RouteDescriptor } from "../../RouteDescriptor";
import { Route } from "../../Route";
import { ForBrokersPage } from "../../../../../pages/General/ForBrokers/ForBrokersPage";
import { groupAll } from "../../../roles/groups";
import { defineMessage } from "react-intl";

const TitleMessage = defineMessage({
  id: "forBrokersRoute.title",
  defaultMessage: "For Brokers",
});

export const forBrokers: RouteDescriptor<Route.forBrokers> = {
  route: Route.forBrokers,
  render: ForBrokersPage,
  title: TitleMessage,
  path: "/for-brokers",
  allowRoles: [...groupAll],
  redirectToHomeRoles: [],
  showInSidebar: false,
};
